import React, { useState, useContext } from "react";
import {
  Typography,
  Stack,
  TextField,
  Button,
  InputAdornment,
  Avatar,
} from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import * as Yup from "yup";
import { string, ref } from "yup";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import moment from "moment";
//Srcs
import "./login.scss";
import { AuthContext } from "../Context/AuthContext";
import loginImage from "../Assets/School_logo.svg";
import CircularProgress from "@mui/material/CircularProgress";
import { CHANGE_PASSWORD_MAINUSER_AFTER_RESET_PASSWORD } from "../Schema/User";

export default function ChangePwAfterResetPw() {
  const navigate = useNavigate();

  const { setAlert, dispatch } = useContext(AuthContext);
  const [iconReload, setIconReload] = useState(false);

  // hide password hook
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  const [changePasswordMainUserAfterResetPassword] = useMutation(
    CHANGE_PASSWORD_MAINUSER_AFTER_RESET_PASSWORD,
    {
      onCompleted: ({ changePasswordMainUserAfterResetPassword }) => {
        // console.log("changePasswordMainUserAfterResetPassword::", changePasswordMainUserAfterResetPassword)
        if (changePasswordMainUserAfterResetPassword?.status) {
          setAlert(
            true,
            "success",
            changePasswordMainUserAfterResetPassword?.message
          );
          window.localStorage.setItem(
            "token",
            JSON.stringify(changePasswordMainUserAfterResetPassword?.token)
          );

          window.localStorage.setItem(
            "role",
            JSON.stringify(changePasswordMainUserAfterResetPassword?.role)
          );

          dispatch({
            type: "LOGGED_IN_USER",
            payload: {
              email: "customtoken@user.com",
              token: changePasswordMainUserAfterResetPassword?.token,
            },
          });

          setTimeout(() => {
            navigate("/dashboard");
            window.location.reload();
            setIconReload(false);
          }, 1000);
        } else {
          setAlert(
            true,
            "error",
            changePasswordMainUserAfterResetPassword?.message
          );
          // setIconReload(false);
          // window.location.reload("/");
          // navigate("/login");
          // window.localStorage.removeItem("userLogin");
          // window.localStorage.removeItem("token");
        }
      },
      onError: (err) => {
        setAlert(true, "error", err?.message);
        window.location.reload("/login");
        navigate("/login");
        window.localStorage.removeItem("userLogin");
        window.localStorage.removeItem("token");
      },
    }
  );

  const CheckValidation = Yup.object().shape({
    newPassword: Yup.string()
      .required("required!")
      .min(10, "Please input more then 10 charactor!"),
    confirmPassword: string()
      .required("require!")
      .oneOf([ref("newPassword")], "Wrong password!"),
  });

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setIconReload(true);
      changePasswordMainUserAfterResetPassword({
        variables: {
          newPassword: values?.newPassword,
        },
      });
    },
  });

  const { errors, touched, handleSubmit, getFieldProps } = formik;

  return (
    <Stack
      direction="column"
      justifyContent="center"
      className="login-container"
    >
      <Stack direction="row" justifyContent="center" sx={{ width: "100%" }}>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack direction="column" className="box-container" spacing={3}>
              <Stack direction="column" spacing={1}>
                <Stack direction="row" justifyContent="center">
                  <Avatar
                    sx={{ width: 100, height: 100 }}
                    variant="square"
                    alt="logo"
                    src={loginImage}
                  />
                </Stack>
                <Typography
                  variant="body2"
                  align="center"
                  className="login-subtitle"
                >
                  Accounting Management
                </Typography>
              </Stack>

              <Stack
                direction="column"
                justifyContent="center"
                width="100%"
                className="box-login"
                spacing={2}
              >
                <Stack direction="column" spacing={0.5}>
                  <Typography className="label-login">New password</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="password"
                    type={show ? "text" : "password"}
                    {...getFieldProps("newPassword")}
                    error={Boolean(touched.newPassword && errors.newPassword)}
                    helperText={touched.newPassword && errors.newPassword}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start" onClick={handleClick}>
                          {show ? (
                            <VisibilityIcon className="viewpw-icon" />
                          ) : (
                            <VisibilityOffIcon className="viewpw-icon" />
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Stack>
                <Stack direction="column" spacing={0.5}>
                  <Typography className="label-login">
                    Confirm password
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    className="text-field"
                    type={show ? "text" : "password"}
                    placeholder={"confirm password"}
                    {...getFieldProps("confirmPassword")}
                    error={Boolean(
                      touched.confirmPassword && errors.confirmPassword
                    )}
                    helperText={
                      touched.confirmPassword && errors.confirmPassword
                    }
                  />
                </Stack>
              </Stack>
              <Stack direction="column">
                <Button
                  className="btn-sign-in"
                  type="submit"
                  endIcon={
                    iconReload ? (
                      <CircularProgress sx={{ color: "#fff" }} size="20px" />
                    ) : null
                  }
                >
                  Sign In
                </Button>
              </Stack>
              <Typography className="footer-copy-right">
                Copyright © {moment().format("YYYY")} Go Global IT. All rights
                reserved.
              </Typography>
            </Stack>
          </Form>
        </FormikProvider>
      </Stack>
    </Stack>
  );
}
